import styled from 'styled-components';

export const VideoWrapper = styled.div.withConfig({
  displayName: 'VideoWrapper',
  componentId: 'video-wrapper',
})([
  ({ alignment }) => `
    margin-bottom: ${alignment === 'Mittig' ? '32px' : '0'};
    position: relative;

    ${alignment === 'Links' || alignment === 'Rechts' ? `
        width: 50%;
        flex-shrink: 0;

        @media screen and (max-width: 767px) {
            width: 100%;
            margin-bottom: 16px;
        }
    ` : `
        width: 100%;
    `}

    > video {
      width: 100%;
      ${alignment === 'Mittig' ? `
        height: calc((100vw - 57px) * 9 / 16) !important;

        @media screen and (min-width: 961px) {
          height: calc((100vw - 65px) * 9 / 16) !important;
        }

        @media screen and (min-width: 1185px) {
          height: calc(1120px * 9 / 16) !important;
        }

        @media screen and (min-width: 1281px) {
          height: calc((836px * 9) / 16) !important;
        }
      ` : `
        aspect-ratio: 16 / 9;
        height: auto;

        @media screen and (max-width: 767px) {
          height: calc((100vw - 57px) * 9 / 16) !important;
        }
      `}
    }

    p {
        margin: 8px 0;
        letter-spacing: 0.6px;
    }
`,
]);
